import Vue, { PluginObject } from 'vue';
import Component from 'vue-class-component';
import {Prop, Inject} from 'vue-property-decorator';
import {Tooltip} from '../tooltip/tooltip'; 
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);

require('../../../../icons/questioncircleo.svg');

@Component({
  template: require('./form-item.html'),
  name: 'wc-form-item',
  components: {
    'wc-tooltip': Tooltip
  },
  
})
export class FormItem extends Vue {
  @Inject()
  $validator;

  @Prop()
  label: string;

  @Prop()
  required: boolean;

  @Prop({
    default: true
  })
  inline: boolean;
  
  @Prop()
  help: string;

  @Prop({
    default: '___defaultName'
  })
  name: string;

  @Prop({
    default: 'column-25'
  })
  additionalClass: string;

}




// WEBPACK FOOTER //
// src/../~/wc-lib/src/wc-ui/components/form/form-item.ts